import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import api from "../../lib/api";
import { btnSecondary, errMsg } from "./ui";

export default function BackupUpload({ onDone }) {
  const ref = useRef(null);
  const [progress, setProgress] = useState(null);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.name.endsWith(".mqlbak")) { toast.error("Pilih file .mqlbak hasil unduhan backup"); return; }
    setProgress(0);
    try {
      const { data: init } = await api.post("/admin/backups/upload", { size: file.size, filename: file.name });
      const total = Math.ceil(file.size / init.chunk_size);
      for (let i = 0; i < total; i++) {
        const chunk = file.slice(i * init.chunk_size, (i + 1) * init.chunk_size);
        await api.put(`/admin/backups/upload/${init.upload_id}/${i}`, chunk, { headers: { "Content-Type": "application/octet-stream" } });
        setProgress(Math.round(((i + 1) / total) * 100));
      }
      const { data } = await api.post(`/admin/backups/upload/${init.upload_id}/complete`);
      toast.success(data.existing ? "Backup ini sudah ada di daftar" : "File backup diunggah. Klik Restore pada backup tersebut untuk memulihkan data.");
      onDone(data.backup_id);
    } catch (err) { toast.error(errMsg(err)); } finally { setProgress(null); }
  };
  return (
    <>
      <input ref={ref} data-testid="backup-upload-input" type="file" accept=".mqlbak" className="hidden" onChange={pick} />
      <button data-testid="backup-upload-btn" onClick={() => ref.current?.click()} disabled={progress !== null} className={`${btnSecondary} flex items-center gap-2`}>
        <Upload size={16} /> {progress !== null ? `Mengunggah ${progress}%` : "Unggah File Backup (.mqlbak)"}
      </button>
    </>
  );
}
